export function valueToId(value: string): string {
  return value.replace(/\s+/g, '_');
}

//Keep for future use
// export function updateHashById(value: string) {
//   const id = valueToId(value);
//   const url = new URL(window.location.href);
//   url.hash = id;
//   window.history.replaceState(null, '', url.toString());
// }
//
// export function getInitialValueFromHash(values: Array<string>): string | null {
//   if (typeof window === 'undefined') return null;
//
//   const raw = window.location.hash.slice(1);
//   if (!raw) return null;
//
//   const matched = values.find((v) => valueToId(v) === raw);
//   return matched ?? null;
// }
